import { Outlet, Route, Routes } from "react-router-dom";
import routes from "./utils/routes";
import FinEaseAdminLayout from "./layouts/FineaseAdminLayout";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminProtectedRoute from "@/components/auth/AdminProtectedRoute";

const FinEaseHomeApp = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];
  return (
    <Routes>
      <Route element={<Outlet />}>
        {/* Public routes - accessible without authentication */}
        {publicRoutes.map(({ path, element: Page }) => (
          <Route key={path} path={path} element={<Page />} />
        ))}

        {/* Admin-only protected routes */}
        <Route element={<AdminProtectedRoute />}>
          <Route element={<FinEaseAdminLayout />}>
            {authRoutes.map(({ path, element: Page }) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default FinEaseHomeApp;
